import { firestoreRef } from "api";
import { PrimaryButton } from "components/Buttons/PrimaryButton";
import { AuthCardTitle } from "../styled";
import { completeSignup } from "../firebase";
import Col from "components/Col";
import { Input } from "components/Inputs/Input";
import Row from "components/Row";
import { uploadImageToStorage } from "modules/profile/firebase";
import ProfilePic from "modules/profile/ProfilePic";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { InputAdornment } from "@material-ui/core";

export default function CompleteSignUpPage({ history }) {
  const [form, setForm] = useState({
    name: "",
    photo_url: "",
    email: "",
    phone: ""
  });
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [user, setUser] = useState(null);
  const userId = useSelector(state => state.authState.firestoreUser.uid);

  const photoInputRef = useRef(null);

  var firestoreUser = useSelector(state => state.authState.firestoreUser);

  useEffect(() => {
    setForm({
      name: firestoreUser.name || "",
      photo_url: firestoreUser.photo_url || "",
      email: firestoreUser.email || "",
      phone: firestoreUser.phone || ""
    });
  }, [firestoreUser]);

  useEffect(() => {
    firestoreRef
      .collection("users")
      .doc(userId)
      .onSnapshot(doc => {
        setUser(doc.data());
      });
  }, [userId]);

  const handleInput = event => {
    setForm({
      ...form,
      [event.target.name]: event.target.value
    });
  };

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      let profileImageUrl = user && user.photo_url;
      if (selectedImage) {
        profileImageUrl = await uploadImageToStorage(
          selectedImage,
          selectedImage.name
        );
      }
      var data = {
        ...form,
        photo_url: profileImageUrl
      };
      await completeSignup(data);
      setLoading(false);
      history.push("/");
    } catch (err) {
      alert(err);
    } finally {
      setLoading(false);
    }
  }

  function openBrowseWindow() {
    photoInputRef.current.click();
  }

  return (
    <React.Fragment>
      <AuthCardTitle>Complete Sign Up</AuthCardTitle>
      <form onSubmit={submit}>
        <Col style={{ alignItems: "center", marginTop: 16 }}>
          <ProfilePic
            onPress={openBrowseWindow}
            selectedImage={selectedImage}
            user={user}
          />
          <input
            ref={photoInputRef}
            type="file"
            accept="image/x-png,image/gif,image/jpeg"
            onChange={e => {
              if (e.target.files.length !== 0) {
                const file = e.target.files[e.target.files.length - 1];
                setSelectedImage(file);
              }
            }}
            style={{ display: "none" }}
          />
        </Col>

        <Input
          required
          type="text"
          label="Name"
          name="name"
          value={form.name}
          onChange={handleInput}
          margin="normal"
        />
        {form.email ? (
          <Input
            required
            type="email"
            id="outlined-email"
            label="Email"
            name="email"
            disabled={true}
            value={form.email}
            onChange={handleInput}
            margin="normal"
          />
        ) : null}

        <Input
          label="Phone Number"
          name="phone"
          type="number"
          value={form.phone}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">+977</InputAdornment>
            )
          }}
          onChange={handleInput}
          margin="normal"
        />
        <Row justify="space-between">
          <PrimaryButton type="submit" loading={loading}>
            Continue
          </PrimaryButton>
        </Row>
      </form>
    </React.Fragment>
  );
}
